<template>
  <v-container
    fluid
    class="mt-2"
    :class="
      $vuetify.breakpoint.mdAndUp
        ? 'py-5 px-10'
        : '' && $vuetify.breakpoint.smAndUp
        ? 'py-2 px-2'
        : ''
    "
  >
    <PageHeader title="Bookmark Management" />

    <v-row class="mt-6">
      <v-col cols="12" md="6">
        <v-card class="h-100" elevation="3">
          <v-card-title class="text-h5">
            <v-icon left color="primary" large>mdi-download</v-icon>
            Export Bookmarks
          </v-card-title>
          <v-card-text>
            <p class="text-body-1 mb-4">
              Export your LinkBook.io bookmarks as an HTML file that you can
              import back into your browser or use with other bookmark services.
            </p>
            <ExportBookmark />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="h-100" elevation="3">
          <v-card-title class="text-h5">
            <v-icon left color="secondary" large>mdi-upload</v-icon>
            Import Bookmarks
          </v-card-title>
          <v-card-text>
            <p class="text-body-1 mb-4">
              Import your browser bookmarks into LinkBook.io to organize and
              manage them better. Your bookmarks will be automatically organized
              by domain.
            </p>
            <v-btn
              color="secondary"
              large
              block
              to="/import-bookmarks"
              class="mb-3"
            >
              <v-icon left>mdi-upload</v-icon>
              Go to Import Page
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col cols="12">
        <v-card elevation="2">
          <v-card-title class="text-h6">
            <v-icon left color="info">mdi-help-circle</v-icon>
            Need Help?
          </v-card-title>
          <v-card-text>
            <p class="text-body-2 mb-3">
              Learn how to export bookmarks from your browser and import them
              into LinkBook.io, or export LinkBook.io bookmarks back to your
              browser.
            </p>
            <v-btn color="info" outlined to="/bookmark-guide">
              <v-icon left>mdi-book-open-variant</v-icon>
              View Complete Guide
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import ExportBookmark from '@/components/utils/ExportBookmark'

export default {
  name: 'BookmarkManagement',
  components: {
    PageHeader,
    ExportBookmark
  },
  metaInfo: {
    title: 'Bookmark Management | Import & Export Bookmarks',
    titleTemplate: '%s - LinkBook.io',
    meta: [
      {
        name: 'description',
        content:
          'Import and export bookmarks between LinkBook.io and your browser. Easily transfer bookmarks with our complete bookmark management tools.'
      },
      {
        name: 'keywords',
        content:
          'bookmark management, import bookmarks, export bookmarks, bookmark transfer, browser bookmarks'
      }
    ]
  }
}
</script>

<style scoped>
.h-100 {
  height: 100%;
}
</style>
